module.exports = function() {
  return new Worker(__webpack_public_path__ + "b5462e1db929cc86a6c3.worker.js");
};